import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'
import { DesignSystemProvider } from '@/design-system'
import { AxiosProvider } from '@/context/Axios'
import '@/design-system/css/variables.css'

const Root = styled(Box)({
  minHeight: '100vh',
  backgroundColor: 'var(--ds-surface)',
  color: 'var(--ds-ink)',
  fontFamily: 'var(--ds-font)',
})

/** Public shared album — Axios for public APIs when available */
export function GuestAlbumLayout() {
  return (
    <AxiosProvider>
      <DesignSystemProvider>
        <Root className='ds-canvas'>
          <Outlet />
        </Root>
      </DesignSystemProvider>
    </AxiosProvider>
  )
}
